<script lang="ts">
    import { _ } from "svelte-i18n"
    import { deployTarget, sentryEnvironment, services, socialMedia } from "../../config"
    import { langField } from "../../i18n"
    import { categoryPathMap, preselectedDealerNumber } from "../../store"
    import Icon from "../widgets/Icon.svelte"
    import { mdiEmailOutline, mdiFactory, mdiPhone, mdiLinkedin, mdiInstagram, mdiYoutube, mdiFacebook } from "@mdi/js"

    $: root = $categoryPathMap[""]
</script>

<footer id="footer">
    <div class="container">
        <section class="footer_menus">
            <div class="row upper">
                <div class="col">
                    <h3>{$_("footer.contact")}</h3>
                    <ul>
                        <li>
                            <span><Icon size="0.6" path="{mdiFactory}" /></span>
                            <p>Erwin Renz Metallwarenfabrik GmbH & Co KG</p>
                        </li>
                        <li>
                            <span><Icon size="0.6" path="{mdiPhone}" /></span>
                            <a href="tel:+7144 3010">07144 3010</a>
                        </li>
                        <li>
                            <span><Icon size="0.6" path="{mdiEmailOutline}" /></span>
                            <a href="mailto:info@renz24.de">info@renz24.de</a>
                        </li>
                    </ul>
                </div>

                <div class="col">
                    <h3>{$_("footer.social-media")}</h3>
                    <ul class="icons">
                        <li>
                            <a href="{socialMedia.linkedIn}" target="_blank"><Icon path="{mdiLinkedin}" /></a>
                        </li>
                        <li>
                            <a href="{socialMedia.instagram}" target="_blank"><Icon path="{mdiInstagram}" /></a>
                        </li>

                        <li>
                            <a href="{socialMedia.facebook}"><Icon path="{mdiFacebook}" /></a>
                        </li>

                        <li>
                            <a href="{socialMedia.xing}" target="_blank"
                                ><img style="height: 30px;" src="/media/xing.svg" alt="xing" /></a
                            >
                        </li>
                    </ul>
                </div>

                <div class="col">
                    <h3>{$_("footer.sustainability")}</h3>
                    <div class="sustainabillity-box box">
                        <span><img src="/media/carbon_energy-renewable.svg" alt="erneuerbare energie" /></span>
                        <p>{$_("footer.sustainability-text")}</p>
                    </div>
                </div>
                <div class="col">
                    <h3>{$_("footer.we-ship-with")}</h3>
                    <div class="dpd-box box">
                        <span><img src="/media/dpd.svg" alt="DPD" /></span>
                    </div>
                </div>
            </div>
            <div class="row">
                {#each root?.childObjects || [] as node, idx}
                    {#if !$preselectedDealerNumber}
                        <div class="col">
                            <h3>{langField(node.name, "")}</h3>
                            <ul>
                                <li>
                                    <a href="{langField(node.path, '')}">{$_("footer.overview")}</a>
                                </li>
                                {#each node.childObjects || [] as subNode}
                                    <li>
                                        <a href="{langField(subNode.path, '')}">{langField(subNode.name, "")}</a>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    {/if}
                {/each}

                <!--
                <div class="col">
                    <h3><a href="/service/kontakt">Kontakt</a></h3>
                    <h3>Newsletter</h3>
                    <form action="" class="form newsletter_form">
                        <input type="email" placeholder="E-Mail" />
                        <input type="submit" value="Abonnieren" />
                    </form>
                </div>
                -->

                <div class="col">
                    <h3>{$_("footer.shop-service")}</h3>
                    <ul>
                        {#each services as s}
                            {#if !$preselectedDealerNumber || s.inPreselectedDealerView}
                                <li>
                                    <a href="/service/{s.url}">{s.title}</a>
                                </li>
                            {/if}
                        {/each}
                    </ul>
                </div>
            </div>
        </section>
    </div>
</footer>

<style lang="less">
    @import "../../css/variables.less";

    #footer {
        background: var(--comp--footer--background);
        color: var(--comp--footer--color);
        font-size: 0.9em;
        padding: 60px 0px;
        position: relative;
        h3 {
            font-size: 1rem;
        }
        .footer_menus {
            margin-top: 40px;
            h3 {
                font-weight: 700;
                border-bottom: solid 1px var(--border-color-default);
                margin: 0 0 20px 0;
                padding-bottom: 6px;
                a {
                    color: var(--comp--footer--color);
                }
            }
            ul {
                list-style-type: none;
                margin: 0 0 30px 0;
                padding: 0;

                li {
                    @media @mobile_only {
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    a {
                        font-size: 0.8rem;
                        color: var(--comp--footer--color);
                        display: block;
                        margin-bottom: 5px;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
            .upper {
                .col {
                    ul {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                        @media (min-width: @res-desktop) {
                            gap: 20px;
                        }

                        li {
                            display: flex;
                            gap: 10px;
                            margin: 0px;
                            align-items: start;

                            p,
                            a {
                                margin: 0px;
                                font-size: 1rem;
                                display: flex;
                                align-items: flex-end;
                            }
                            img {
                                height: 15px;
                            }
                        }
                        &.icons {
                            flex-direction: row;

                            flex-wrap: wrap;
                            gap: 15px;
                        }
                    }
                    .box {
                        padding: 10px 15px;
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        border-radius: 5px;
                        width: 100%;
                        min-height: 78px;
                        &.sustainabillity-box {
                            background-color: #27ae60;
                            color: white;
                            p {
                                margin: 0px;
                            }
                            img {
                                height: 52px;
                            }
                        }
                        &.dpd-box {
                            justify-content: center;
                            img {
                                height: 40px;
                            }
                            background-color: white;
                        }
                    }
                }
            }
        }
    }
</style>
